module.exports = __webpack_public_path__ + "img/Icon - Report or Flag.c64963e7.svg";